import { useEffect, useState } from "react";
import RenderParamInput from "./RenderInputParam";

export default function ParametrosDeEntrada({
  node,
  onParamChange,
  options,
  onChangeNode,
  onRefreshParams = () => {},
  visibleEditMode,
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(visibleEditMode);
  }, [visibleEditMode]);

  return (
    <div className="parametro-container mt-2">
      {node?.params
        ?.filter((e) => e.type === "input")
        ?.map((param) => (
          <RenderParamInput
            data={param}
            id_node={node.id}
            onParamChange={onParamChange}
            options={options}
            textOnly={false}
            dynamicInput={onChangeNode}
            onRefreshParams={onRefreshParams}
            hide_type={node?.hide_type}
            visibleEditMode={visible}
          />
        ))}
    </div>
  );
}
